import { useWindowSize } from "@vueuse/core";
import { useI18n } from "vue-i18n";

export function fnCheckQueryRef(refValue) {
    var storeKey = "query-ref";
    var storeRef = undefined;
    if (process.client) {
        var store=localStorage.getItem(storeKey);
        storeRef = store == null || store === "false" ? false : true;
    }

    var res = false;

    if (storeRef === undefined || !storeRef) {
        const urlParams = new URLSearchParams(window?.location?.search);

        res = urlParams.get('ref') === refValue;

        if (process.client)
            localStorage.setItem(storeKey, res);
    }
    else
        res = storeRef;

    return res; // Check if 'ref' matches the specified value
}

export function fnWindowWidth() {
    const { width, height } = useWindowSize();
    let windowWidth = ref(width);

    return windowWidth !== undefined ? windowWidth : window?.outerWidth;
}

export function fnGetLanguageCode() {
    switch (useI18n().locale.value) {
        case "ar":
            return 2;
        case "en":
            return 3;
        default:
            return 1;
    }
}


